import { AnalyticsConfiguration, interactionEvent } from '@rci/self-serve-fido/core/analytics';

const page = (name = 'overview', hierarchy = ['myaccount', 'overview']) => ({
  name,
  hierarchy,
});

const getInteractionObject = (name, type = 'click') => ({
  type,
  name,
});

const analyticsPayload = (interactionName: string) => ({
  events: interactionEvent,
  page: page(),
  interaction: getInteractionObject(interactionName),
});

export const secondaryNavAnalyticsConfig = {
  DropdownPromiseToPayCTAConfig: {
    mappingKey: 'dropdownPromiseToPayCTA',
  },
  orders: {
    mappingKey: 'orders',
  },
  offers: {
    mappingKey: 'offers',
  },
};

export const secondaryNavAnalyticsConfiguration: AnalyticsConfiguration = {
  mappings: {
    dropdownPromiseToPayCTA: analyticsPayload('drop down|set up promise to pay'),
    orders: {
      events: interactionEvent,
      interaction: getInteractionObject('drop down|my orders'),
    },
    offers: {
      events: interactionEvent,
      interaction: getInteractionObject('my offers'),
    },
  },
};
